import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	button: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[600]),
		height: theme.spacing(2.75),
		borderRadius: theme.spacing(0.5),
		minWidth: 34,
		padding: theme.spacing(1, 1.5),
		fontSize: theme.spacing(1.5),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.blue[500]),
			cursor: "pointer"
		}
	},
	buttonText: {
		fontStyle: "normal",
		fontSize: theme.spacing(1.75),
		color: colors.gray[950],
		fontWeight: 500,
		paddingLeft: theme.spacing(0.5),
		height: "100%",
		paddingBottom: theme.spacing(2.75)
	},
	tabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		}
	},
	tabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600])
	},
	tab: {
		color: `${colors.gray[400]} !important`,
		opacity: 1,
		fontSize: 14
	}
}))

export default useStyles
